import ProfileAPIClientHTTP from 'frontcore/domain/profile/api/ProfileAPIClientHTTP'
import { ProfileAPIClient } from 'frontcore/domain/profile/model/Profile.d'

export class ProfileAPIClientFactory {
  static build (): ProfileAPIClient {
    return new ProfileAPIClientHTTP()
  }
}
